import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async list({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.setting_default_param.list'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
